var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconExclamationOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2364_5106)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 0C8.02219 0 6.08879 0.58649 4.4443 1.6853C2.79981 2.78412 1.51809 4.3459 0.761209 6.17317C0.00433286 8.00043 -0.193701 10.0111 0.192152 11.9509C0.578004 13.8907 1.53041 15.6725 2.92894 17.0711C4.32746 18.4696 6.10929 19.422 8.0491 19.8079C9.98891 20.1937 11.9996 19.9957 13.8268 19.2388C15.6541 18.4819 17.2159 17.2002 18.3147 15.5557C19.4135 13.9112 20 11.9778 20 10C19.9971 7.34872 18.9426 4.80684 17.0679 2.9321C15.1932 1.05736 12.6513 0.00286757 10 0V0ZM10 18.3333C8.35183 18.3333 6.74066 17.8446 5.37025 16.9289C3.99984 16.0132 2.93174 14.7117 2.30101 13.189C1.67028 11.6663 1.50525 9.99076 1.82679 8.37425C2.14834 6.75774 2.94201 5.27288 4.10745 4.10744C5.27289 2.94201 6.75774 2.14833 8.37425 1.82679C9.99076 1.50525 11.6663 1.67027 13.189 2.301C14.7118 2.93173 16.0132 3.99984 16.9289 5.37025C17.8446 6.74066 18.3333 8.35182 18.3333 10C18.3309 12.2094 17.4522 14.3276 15.8899 15.8899C14.3276 17.4522 12.2094 18.3309 10 18.3333Z",
    fill: "#FF7206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0001 4.16699C9.77913 4.16699 9.56717 4.25479 9.41089 4.41107C9.25461 4.56735 9.16681 4.77931 9.16681 5.00033V11.667C9.16681 11.888 9.25461 12.1 9.41089 12.2562C9.56717 12.4125 9.77913 12.5003 10.0001 12.5003C10.2212 12.5003 10.4331 12.4125 10.5894 12.2562C10.7457 12.1 10.8335 11.888 10.8335 11.667V5.00033C10.8335 4.77931 10.7457 4.56735 10.5894 4.41107C10.4331 4.25479 10.2212 4.16699 10.0001 4.16699Z",
    fill: "#FF7206"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 15.0003C10.8335 14.5401 10.4604 14.167 10.0001 14.167C9.53991 14.167 9.16681 14.5401 9.16681 15.0003C9.16681 15.4606 9.53991 15.8337 10.0001 15.8337C10.4604 15.8337 10.8335 15.4606 10.8335 15.0003Z",
    fill: "#FF7206"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2364_5106"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExclamationOrange);
export default __webpack_public_path__ + "static/media/icon-exclamation-orange.bdb0d83226a7f1eef71b0187cb795ef6.svg";
export { ForwardRef as ReactComponent };